import { NTEntity, NTEntityService } from "@nt-portal/server-sdk";
import { ControllerOptions, DataController } from "../../../types";
import { BaseClientService } from "../base-client.service";
import { ResultData } from "@nt-portal/common-sdk";

export interface EntityOptions extends ControllerOptions<NTEntity> {

}

export const initEntity = () => {
    let item: NTEntity = {
        createdBy: "",
        name: "",
        key: "",
        module: ""
    }
    return item;
}

export class ClientEntityService extends BaseClientService implements DataController<NTEntity> {

    private _service: NTEntityService;


    constructor() {
        super();
        this._service = new NTEntityService({
            apiService: this.apiService,
            url: this.settings.fabrixServer
        });
    }
    
   public async get(options: EntityOptions): Promise<ResultData<NTEntity>> {

        return await this._service.get(this.buildFetchParams(options), this.token, options.filter);
       
    }
    public async getLookup(options: EntityOptions): Promise<ResultData<NTEntity>> {
        let fetchParams = this.buildLookupFetchParams(options);
        let data = await this._service.get(fetchParams, this.token, options.filter);
        return data;
    }

    public async getById(options: EntityOptions): Promise<NTEntity | null> {
        if (options.id) {
            let item = await this._service.getById(options.id, this.token);
            return item;
        }
        return null;
    }
    
   


}